import React, { useState } from 'react';
import { Sunburst } from 'react-vis';
import { useHistory } from 'react-router-dom';
import { BiTable } from 'react-icons/bi';
import { FiColumns } from 'react-icons/fi';

const getKeyPath = (node) => {
  if (!node.parent) {
    return ['root'];
  }

  return [(node.data && node.data.name) || node.name].concat(
    getKeyPath(node.parent)
  );
}

const updateData = (data, keyPath) => {
  if (data && data.children) {
    data.children.map(child => updateData(child, keyPath));
  }
  data.style = {
    ...data.style,
    fillOpacity: keyPath && !keyPath[data.name] ? 0.2 : 1
  };

  return data;
}

const TableEntitySunburst = (props) => {
  const [clicked, setClicked] =useState(props.details.clicked);
  const [label, setLabel] = useState(props.label);
  const history = useHistory();
  const details = props.details ?  props.details : {};

  let data = props.data;
  let map = { root: true }
  if (details.table) map[details.table] = true;
  if (details.field) map[details.field] = true;
  if (details.entity) map[details.entity] = true;

  if (details.table || details.field || details.entity) {
    data = updateData(data,map);
  } else {
    data = updateData(data,false)
  }

  const onValueMouseOverHandler = (node) => {
    if (clicked) {
      return;
    }

    const path = getKeyPath(node).reverse();
    let len = path.length - 1;
    let newLabel = label;

    switch(len) {
      case 1:
        newLabel = `Field ${path[len]}`
      break
      case 2:
        newLabel = `${path[len]}`
      break
      case 3:
        newLabel = ` ${path[len]} ${"\n"}(${node.value})`
      break
    }

    setLabel(newLabel);
  }

  const onValueClickHandler = (v) => {
    if (v.children) {
      props.filterDataHandler(v.name);
    } else {
      history.push(`/results/${props.search}/${v.name}/${props.table}`);
    }
  }

  const style = {
    stroke: '#D9DDE3',
    strokeOpacity: 0.3,
    strokeWidth: '0.5' 
  };

  return (
    <div className="d-flex justify-content-center">
      <div className="sunburst-icon-label">
        { props.filteredByCol === null ? label : props.filteredByCol }
      </div>
      {props.filteredByCol === null ? 
        <BiTable className="sunburst-icon" /> : 
        <FiColumns className="sunburst-icon" />
      } 
      <Sunburst
        animation
        hideRootNode
        onValueMouseOver={(node) => onValueMouseOverHandler(node)}
        onValueMouseOut={() => setLabel(props.label)}
        // onValueClick={() => setClicked(!clicked)}
        style={style}
        colorType="literal"
        getColor={d => d.hex}
        getSize={d => d.value}
        data={data}
        height={235}
        width={350}
        onValueClick={(v) => onValueClickHandler(v)}
      />
    </div>
  );
}

export default TableEntitySunburst;